import type {
    EventContainerConstraint,
    EventContainerScheduleCallDisableConfig,
    EventContainerTemplateConfiguration,
} from "~/domainModels/workspaceModules/eventContainersModule";
import {
    AMARON_JOURNEY_NON_EDITABLE_LEAD_STATUS_GLOBAL_CONSTRAINTS,
    AMARON_JOURNEY_SCHEDULE_CALL_DISABLE_CONFIG,
    isAmaronWorkspace,
} from "~/domainModels/workspaceSpecific/amaron";
import {
    DULUX_JOURNEY_NON_EDITABLE_LEAD_STATUS_GLOBAL_CONSTRAINTS,
    isDuluxWorkspace,
} from "~/domainModels/workspaceSpecific/dulux";
import type {WorkspaceCapability} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapability";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";

export function resolveEventContainerDetailsPageGlobalConstraints(args: {
    workspace: {displayName: string};
    workspaceCapabilities: ReadonlyArray<WorkspaceCapability<WorkspaceCapabilityType>>;
    eventContainerDetailsPage: Pick<
        EventContainerTemplateConfiguration["eventContainerDetailsPage"],
        "globalConstraints"
    >;
}): Array<EventContainerConstraint> | undefined {
    if (isAmaronWorkspace(args.workspaceCapabilities) === true) {
        return AMARON_JOURNEY_NON_EDITABLE_LEAD_STATUS_GLOBAL_CONSTRAINTS;
    }
    if (isDuluxWorkspace(args.workspaceCapabilities) === true) {
        return DULUX_JOURNEY_NON_EDITABLE_LEAD_STATUS_GLOBAL_CONSTRAINTS;
    }
    return args.eventContainerDetailsPage.globalConstraints;
}

export function resolveEventContainerEditPanelGlobalConstraints(args: {
    workspace: {displayName: string};
    workspaceCapabilities: ReadonlyArray<WorkspaceCapability<WorkspaceCapabilityType>>;
    editPanel?: Pick<
        NonNullable<
            EventContainerTemplateConfiguration["eventContainersPage"]["editPanel"]
        >,
        "globalConstraints"
    >;
}): Array<EventContainerConstraint> | undefined {
    if (isAmaronWorkspace(args.workspaceCapabilities) === true) {
        return AMARON_JOURNEY_NON_EDITABLE_LEAD_STATUS_GLOBAL_CONSTRAINTS;
    }
    if (isDuluxWorkspace(args.workspaceCapabilities) === true) {
        return DULUX_JOURNEY_NON_EDITABLE_LEAD_STATUS_GLOBAL_CONSTRAINTS;
    }
    const configured = args.editPanel?.globalConstraints;
    if (configured === undefined || configured.length === 0) {
        return undefined;
    }
    return configured;
}

export function resolveEventContainerScheduleCallDisableConfig(args: {
    workspace: {displayName: string};
    workspaceCapabilities: ReadonlyArray<WorkspaceCapability<WorkspaceCapabilityType>>;
    eventContainersPage?: Pick<
        EventContainerTemplateConfiguration["eventContainersPage"],
        "scheduleCallDisable"
    >;
    eventContainerDetailsPage?: Pick<
        EventContainerTemplateConfiguration["eventContainerDetailsPage"],
        "scheduleCallDisable"
    >;
    context: "list" | "profile" | "events";
}): EventContainerScheduleCallDisableConfig | undefined {
    if (isAmaronWorkspace(args.workspaceCapabilities) === true) {
        return AMARON_JOURNEY_SCHEDULE_CALL_DISABLE_CONFIG;
    }
    if (args.context === "profile") {
        return args.eventContainerDetailsPage?.scheduleCallDisable;
    }
    return args.eventContainersPage?.scheduleCallDisable;
}
